import Cookie from 'js-cookie'
/*设置cookies*/
export const setCookies = (cookiesObj, options = {}) => {
  const { expires, domain } = options
  for (const cookiesObjKey in cookiesObj) {
    Cookie.set(cookiesObjKey, cookiesObj[cookiesObjKey], { expires, domain })
  }
}
/*移除cookies*/
export const removeCookies = (cookiesArr) => {
  cookiesArr.forEach((item) => {
    Cookie.remove(item)
  })
}
/*获取cookies*/
export const getCookies = (cookiesArr) => {
  const cookiesRes = {}
  cookiesArr.forEach((item) => {
    cookiesRes[item] = Cookie.get(item)
  })
  return cookiesRes
}
